import React, { useEffect, useState } from "react";
import "./TargetDetails.css";
import CollapseItem from "./CollapseItem";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addCategory, reset } from "../../../store/actions/performanceSlice";
import wikiLogo from "../../../Assets/SideBar/logo.png";
function TargetDetails({ allCategories ,getAllCategories }) {
  const [addNewItem, setAddNewItem] = useState(false);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  // The admin's own "default" category: no account (no password, can't log
  // in), targets for analytics only, never any revenue share.
  const [isDefault, setIsDefault] = useState(false);

  const { categoryAdded, error } = useSelector((state) => state.performance);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (name?.length > 0 && (isDefault || password?.length >= 6)) {
      const formData = new FormData();
      // Backend (AdminTargetCategories::store) expects `username` + `password`,
      // not `name` — this used to always 422 because of the field-name mismatch
      // and the missing password. Categories no longer take a custom picture —
      // they all show the same wiki logo icon in the list (see CollapseItem).
      formData.append("username", name);
      if (!isDefault || password) formData.append("password", password);
      if (isDefault) formData.append("is_default", "1");
      dispatch(addCategory(formData));
    }
  };

  useEffect(() => {
    if (categoryAdded) {
      dispatch(reset());
      dispatch(getAllCategories());
      setAddNewItem(false);
      setName("");
      setPassword("");
      setIsDefault(false);
    }
  }, [categoryAdded]);


  return (
    <div className="categories-section py-5 ">
      <div className="mb-5 px-5">
        <button
          style={{
            background:
              addNewItem && "linear-gradient(180deg, #9057E5 0%, #CC475D 100%)",
          }}
          onClick={() => setAddNewItem((prev) => !prev)}
        >
          Add Category {"   "} +{" "}
        </button>
      </div>
      {!addNewItem && (
        <div>
          {allCategories?.data?.map((ele) => (
            <CollapseItem category={ele} />
          ))}
        </div>
      )}

      {addNewItem && (
        <>
          <div className="p-5 d-flex align-items-center justify-content-around">
            <img
              src={wikiLogo}
              alt="Category icon"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "contain",
              }}
            />
            <Form.Group className="mb-3" controlId="userName">
              <Form.Label style={{ fontSize: "25px" }} className="text-white">
                Category Username
              </Form.Label>
              <Form.Control
                style={{
                  background: "#D9D9D9",
                  width: "450px",
                  height: "67px",
                }}
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Username"
              />
              <Form.Check
                type="checkbox"
                id="category-is-default"
                className="text-white mt-3"
                style={{ fontSize: "16px" }}
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
                label="Default category (mine, no account) — targets for analytics only, no revenue share"
              />
              {!isDefault && (
                <>
                  <Form.Label style={{ fontSize: "25px", marginTop: "1rem" }} className="text-white d-block">
                    Password
                  </Form.Label>
                  <Form.Control
                    style={{
                      background: "#D9D9D9",
                      width: "450px",
                      height: "67px",
                    }}
                    type="password"
                    required
                    minLength={6}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password (min 6 characters)"
                  />
                  <div className="text-white-50 mt-2" style={{ fontSize: "14px", maxWidth: 450 }}>
                    A new category starts stopped. Press Start on it when it should begin counting.
                  </div>
                </>
              )}
              {error && (
                <div className="text-danger mt-2" style={{ fontSize: "16px" }}>
                  {error}
                </div>
              )}
            </Form.Group>
          </div>

          <button
            className="mt-4 d-flex align-items-center justify-content-center "
            style={{
              marginLeft: "auto",
              marginRight: "3rem",
              background: "linear-gradient(180deg, #9057E5 0%, #CC475D 100%)",
            }}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </>
      )}
    </div>
  );
}

export default TargetDetails;
